export default {
	props: {
		value: {
			required: true
		},
		ariaControls: {
			required: false
		},
		ariaDescribedby: {}
	},
	inheritAttrs: false,
	data() {
		return {};
	},
	watch: {
		value(val) {
			if (val && val.length == this.$el.maxLength) {
				this.$emit('on-jump');
			}
		}
	},
	methods: {
		onPaste(e) {
			e.preventDefault();
			// nem szamok kiszurese
			let clipboardData = e.clipboardData || window.clipboardData;
			let pasted = clipboardData.getData('Text').replace(/\D/g, '');
			// 06 / 36 / +36 lecsereles
			if (pasted.indexOf('06') == 0 || pasted.indexOf('36') == 0) {
				pasted = pasted.substring(2);
			}
			// maxlength levagas
			pasted = pasted.substring(0, 11);
			e.target.value = this.formatNumber(pasted);
		},
		onInput(e) {
			this.$emit('input', this.formatNumber(e.target.value));
		},
		formatNumber(number) {
			number = number || '';
			let formattedNumber = '';
			number = number.replace(/ /gim, '');
			if (number.substring(0, 1) == '1') {
				if (number.length < 1) {
					formattedNumber = number;
				} else if (number.length >= 4) {
					formattedNumber = number.substring(0, 1) + ' ' + number.substring(1, 4) + ' ' + number.substring(4);
				} else if (number.length >= 1) {
					formattedNumber = number.substring(0, 1) + ' ' + number.substring(1, 4);
				}
			} else {
				if (number.length < 2) {
					formattedNumber = number;
				} else if (number.length >= 5) {
					formattedNumber = number.substring(0, 2) + ' ' + number.substring(2, 5) + ' ' + number.substring(5);
				} else if (number.length >= 2) {
					formattedNumber = number.substring(0, 2) + ' ' + number.substring(2, 5);
				}
			}
			setTimeout(() => {
				if (this.$refs['phone-input'] && this.$refs['phone-input'].offsetParent && this.$refs['phone-input'] == document.activeElement) {
					// csak akkor mókoljon, ha látható
					this.$refs['phone-input'].selectionStart = this.$refs['phone-input'].selectionEnd = 10000;
				}
			}, 0);
			return formattedNumber.trim();
		}
	}
};
